export default function getPath() {
    // Alle Stages verwenden den gleichen API Endpoint
    return 'https://da02fotzo9.execute-api.eu-central-1.amazonaws.com/prod'
}
